<div class="hscode-mapping-dialog">
  <!-- HEADER ACTIONS -->
  <div class="search-row">
    <nz-input-group nzPrefixIcon="search">
      <input 
        nz-input 
        placeholder="Search..." 
        [(ngModel)]="searchText" 
        (keyup.enter)="onSearch()" />
    </nz-input-group>
  </div>
  <!-- /HEADER ACTIONS -->

  <!-- TABLE -->
  <nz-table 
    class="declaration-table" 
    [nzData]="allMappings" 
    [nzScroll]="{ y: '250px' }" 
    [nzFrontPagination]="false" 
    nzSize="middle"
    [nzLoading]="isLoading"
    (nzSortOrderChange)="sort($event)" nzSingleSort>

    <thead>
      <tr>
        <th nzShowSort nzColumnKey="indicatorGroupName" [nzSortFn]="true">Indicator Group Name</th>
        <th nzShowSort nzColumnKey="indicatorGroupCode" [nzSortFn]="true">Indicator Group Code</th>
        <th>ACTION</th>
      </tr>
    </thead>

    <tbody>
      <tr *ngFor="let mapping of allMappings" [class.selected-row]="selectedMappingId === mapping.mappingId">
        <!-- <td>{{ mapping.mappingId }}</td> -->
        <td>{{ mapping.indicatorGroupName }}</td>
        <td>{{ mapping.indicatorGroupCode }}</td>
        <td>
          <button nz-button nzType="link" (click)="selectMapping(mapping)" nz-tooltip nzTooltipTitle="Select HS Code">
            <i nz-icon nzType="arrow-right" nzTheme="outline"></i>
          </button>
        </td>
      </tr>
    </tbody>
  </nz-table>

  <!-- PAGINATION -->
  <div class="mt-md pagination-bar-row" *ngIf="totalMappings > 0">
    <div>
      <nz-pagination 
        [(nzPageIndex)]="pageIndex" 
        [nzTotal]="totalMappings" 
        [nzPageSize]="pageSize" 
        (nzPageIndexChange)="onPageChange($event)">
      </nz-pagination>
    </div>
    <div>
      <span class="mr-sm">Go to:</span>
      <input 
        nz-input 
        [(ngModel)]="gotoPageNumber" 
        placeholder="Page" 
        type="number" 
        [min]="1" 
        [max]="maxPages" 
        class="mr-sm inline-block w58" 
        (keyup.enter)="goToPage()" />
      <button nz-button nzType="primary" (click)="goToPage()" [disabled]="!gotoPageNumber">Go</button>
    </div>
  </div>

  <!-- FOOTER -->
  <div class="footer">
    <div class="btn-wrapper">
      <button nz-button (click)="closeDialog()">Cancel</button>
    </div>
  </div>
</div>
